import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TextConditions from './TextConditions';
import { selectPaisId, selectHeader } from 'legacyfrontend/redux/selectors/application-selectors';

export default function GeneralConditions() {
  const { t } = useTranslation(['layout']);
  const paisId = useSelector(selectPaisId);
  const header = useSelector(selectHeader);
  const company = header.empresa;
  const emailContacto = header.emailContacto;

  return (
    <div className='pt-7 pb-10 py-5 container'>
      <div className='px-12 py-12 bg-white rounded-md'>
        <div className='text-sm text-gray-400 font-bold'>
          {paisId === 1 && (
            <>
              <p className='mb-1'>
                {`Sr. Pasajero, atento su requerimiento de intermediación en la contratación de servicios turísticos , esta Agencia cumple en informarle las condiciones generales de contratación. Es de vital importancia para su viaje, que Ud. lea las mismas. Si está de acuerdo le solicitamos nos envíe  su aceptación al siguiente mail: ${emailContacto}.`}
              </p>
              <p className='mb-6'>
                {`Esta agencia sólo dará tramite a su reserva, previa lectura y conformidad de las mismas. Atte: ${company} Agencia`}
              </p>
            </>
          )}
        </div>
        <h3 className='text-xl text-black text-center'>
          <span className='underline'>
            <strong>
              {paisId === 3 && <span>Política de Privacidade</span>}
              {paisId === 2 && <span>Política de Privacidad</span>}
              {paisId === 1 && <span>{t('footer.generalConditions')}</span>}
            </strong>
          </span>
        </h3>
        <div className='text-sm text-gray-400 py-12'>
          <TextConditions paisId={paisId} />
        </div>
      </div>
    </div>
  );
}
